import { Spinner } from "@/components/common/Spinner";
import { useMe } from "@/hooks/queries/useMe";
import { Navigate } from "@tanstack/react-router";
import dayjs from "dayjs";
import { OPEN_DATE } from "@/shared/config";

type WithAuthGuardOptions = {
  redirectTo?: string;
  LoadingComponent?: React.ReactNode;
};

export const Loading = (
  <div className="flex justify-center items-center w-full h-screen">
    <Spinner size={32} />
  </div>
);

const withAuthGuard = (WrappedComponent: React.ComponentType, options?: WithAuthGuardOptions) => () => {
  const { redirectTo = "/signin", LoadingComponent = Loading } = options || {};

  const { data, error, isFetching } = useMe({
    staleTime: 0,
    refetchOnMount: true
  });

  if (dayjs().isBefore(OPEN_DATE)) {
    return <Navigate to={"/countdown"} />;
  }

  if (isFetching) {
    return <>{LoadingComponent}</>;
  }

  if (error || !data?.user) {
    return <Navigate to={redirectTo} />;
  }

  return <WrappedComponent />;
};

export default withAuthGuard;
